import HttpClient from '../../../services/HttpClient'
import { getCharacterId } from '../../../utils/characterId'

export { getCharacterId, resolveCharacterId } from '../../../utils/characterId'

export async function submitAdventureReply({
  contentNarrative,
  contentOoc,
  content,
  character,
  slug,
  combatTargetCharacterId = null,
}) {
  const narrative = (contentNarrative ?? content ?? '').trim()
  const oocRaw = contentOoc
  const ooc =
    oocRaw === undefined || oocRaw === null ? null : String(oocRaw).trim() || null
  const characterId = getCharacterId(character)

  if (!narrative) {
    return { success: false, data: null, message: 'El contenido narrativo es requerido' }
  }

  if (!characterId) {
    return { success: false, data: null, message: 'No hay personaje válido para publicar.' }
  }

  if (!slug) {
    return { success: false, data: null, message: 'No se pudo identificar la aventura.' }
  }

  try {
    const payload = {
      contentNarrative: narrative,
      characterId,
      slug,
    }
    if (ooc) payload.contentOoc = ooc
    if (combatTargetCharacterId != null && Number(combatTargetCharacterId) > 0) {
      payload.combatTargetCharacterId = Number(combatTargetCharacterId)
    }

    const response = await HttpClient().post('/api/v1/adventure/reply', payload)
    const data = response.data
    const success =
      response.success !== undefined ? !!response.success : !!(data && data.success)
    const replyData =
      response.success !== undefined ? data : (data && data.data !== undefined ? data.data : data)
    const message = response.message || (data && data.message) || ''
    return {
      success,
      data: replyData ?? null,
      message,
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Error al publicar la respuesta.'
    return { success: false, data: null, message }
  }
}
